var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotificationsInsideDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 346,
    viewBox: "0 0 145 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 200L19 1",
    stroke: "#B4BEC0",
    strokeWidth: 0.608477,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.32418,
    cy: 5.32418,
    r: 5.32418,
    transform: "matrix(-1 0 0 1 24.4526 198.052)",
    fill: "#07131A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.19451,
    cy: 3.19451,
    r: 3.19451,
    transform: "matrix(-1 0 0 1 22.3232 206.571)",
    fill: "#07131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9341 206.419L12.1311 211.895V217.676L15.9341 223",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8691 203.529L8.63225 206.571L7.26318 213.569L9.54497 219.653",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6299 201.551L8.48028 198.357L3.1561 203.985V209.614",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1509 199.574L11.2182 194.249V187.86L15.0212 182.384",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3228 206.419L26.1257 211.895V217.676L22.3228 223",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3877 203.529L29.6246 206.571L30.9937 213.569L28.7119 219.653",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.627 201.551L29.7766 198.357L35.1007 203.985V209.614",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.106 199.574L27.0386 194.249V187.86L23.2356 182.384",
    stroke: "#07131A",
    strokeWidth: 1.21695,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30494 328.112C5.12191 318.037 42.0655 310.48 65.0712 310.648C92.2751 305.778 139.462 310.648 143.828 324.082C146.746 333.061 135.432 343.729 112.93 345.744C90.428 347.759 53.8203 337.18 47.7749 338.188C41.7296 339.195 9.48797 338.188 7.30494 328.112Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M137.141 272.333C141.366 297.922 129.734 321.152 111.161 324.218C92.5888 327.284 74.1082 309.025 69.8838 283.436C66.7147 264.239 72.4694 246.37 83.3839 237.346C83.7123 237.075 84.0455 236.811 84.3832 236.556C87.7819 233.986 91.6436 232.248 95.8636 231.552C114.436 228.486 132.917 246.744 137.141 272.333Z",
    fill: "#EEB420"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.161 324.218C92.5888 327.284 74.1082 309.025 69.8838 283.436C66.7147 264.239 72.4694 246.37 83.3839 237.346C55.0473 259.665 49.9823 255.322 35.5169 257.416C22.9487 259.235 11.3942 272.333 12.9547 293.184C13.0756 294.8 13.2621 296.479 13.5187 298.221C13.7921 300.078 14.1652 301.811 14.6249 303.427C20.5381 324.218 39.0957 326.601 49.9847 324.218C65.1743 320.894 75.651 317.197 84.3832 319.884C91.3334 322.022 99.6905 326.112 111.161 324.218Z",
    fill: "#FDD131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5187 298.221C13.2621 296.479 13.0756 294.8 12.9547 293.184C7.13735 293.352 7.16708 304.771 14.6249 303.427C14.1652 301.811 13.7921 300.078 13.5187 298.221Z",
    fill: "#EEB420"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.161 324.218C129.734 321.152 141.366 297.922 137.141 272.333C132.917 246.744 114.436 228.486 95.8636 231.552C91.6436 232.248 87.7819 233.986 84.3832 236.556M111.161 324.218C92.5888 327.284 74.1082 309.025 69.8838 283.436C66.7147 264.239 72.4694 246.37 83.3839 237.346M111.161 324.218C99.6905 326.112 91.3334 322.022 84.3832 319.884C75.651 317.197 65.1743 320.894 49.9847 324.218C39.0957 326.601 20.5381 324.218 14.6249 303.427M84.3832 236.556C84.0469 236.823 83.7138 237.086 83.3839 237.346M84.3832 236.556C84.0455 236.811 83.7123 237.075 83.3839 237.346M12.9547 293.184C11.3942 272.333 22.9487 259.235 35.5169 257.416C49.9823 255.322 55.0473 259.665 83.3839 237.346M12.9547 293.184C13.0756 294.8 13.2621 296.479 13.5187 298.221C13.7921 300.078 14.1652 301.811 14.6249 303.427M12.9547 293.184C7.13735 293.352 7.16708 304.771 14.6249 303.427",
    stroke: "black",
    strokeWidth: 1.67925
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.816,
    cy: 277.504,
    rx: 28.1847,
    ry: 42.326,
    transform: "rotate(-9.37416 105.816 277.504)",
    fill: "#273339",
    stroke: "black",
    strokeWidth: 1.67925
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.605 297.402C84.5613 294.742 87.7132 293.016 91.2682 293.016C97.2037 293.016 102.015 297.828 102.015 303.763C102.015 308.422 99.0512 312.388 94.906 313.879C90.0293 310.002 85.7453 304.313 82.605 297.402Z",
    fill: "#EEB420"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M82.605 297.402L81.9286 296.904L81.6369 297.301L81.8406 297.749L82.605 297.402ZM94.906 313.879L94.3835 314.536L94.7498 314.827L95.1902 314.669L94.906 313.879ZM83.2813 297.899C85.0863 295.445 87.9915 293.855 91.2682 293.855V292.176C87.4349 292.176 84.0364 294.039 81.9286 296.904L83.2813 297.899ZM91.2682 293.855C96.74 293.855 101.176 298.291 101.176 303.763H102.855C102.855 297.364 97.6674 292.176 91.2682 292.176V293.855ZM101.176 303.763C101.176 308.056 98.4444 311.714 94.6218 313.089L95.1902 314.669C99.658 313.062 102.855 308.787 102.855 303.763H101.176ZM95.4285 313.222C90.6735 309.441 86.4649 303.867 83.3694 297.054L81.8406 297.749C85.0257 304.759 89.3851 310.562 94.3835 314.536L95.4285 313.222Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8888 271.053C38.673 267.304 49.2662 265.295 46.1592 262.412C43.2596 259.722 34.1035 261.716 28.2193 266.309C21.7184 271.383 18.6859 279.298 20.7836 280.221C25.7974 281.496 26.989 274.878 32.8888 271.053Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M102.421 257.671L103.761 259.922C106.234 264.074 111.167 266.074 115.833 264.815V264.815L114.71 269.218C113.775 272.885 114.516 276.779 116.733 279.846L119.394 283.529V283.529C114.592 284.072 110.737 287.744 109.962 292.514L109.542 295.1L108.202 292.849C105.729 288.697 100.795 286.697 96.1295 287.956V287.956L97.2523 283.553C98.1876 279.885 97.4468 275.992 95.2301 272.924L92.5689 269.241V269.241C97.371 268.699 101.225 265.027 102.001 260.257L102.421 257.671Z",
    stroke: "white",
    strokeWidth: 0.671701
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M100.011 245.075L104.299 252.277C107.226 257.192 113.066 259.56 118.589 258.07L122.445 257.029L119.575 268.294C118.64 271.96 119.381 275.852 121.596 278.919L128.403 288.342L124.435 288.791C118.75 289.433 114.187 293.78 113.27 299.427L111.927 307.701L107.639 300.498C104.712 295.583 98.8721 293.215 93.3487 294.705L89.4927 295.746L92.3636 284.481C93.298 280.815 92.5575 276.923 90.3421 273.856L83.535 264.433L87.5036 263.984C93.1883 263.342 97.7511 258.995 98.668 253.348L100.011 245.075Z",
    stroke: "white",
    strokeWidth: 0.671701
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.874 265.377L104.637 266.645C106.128 269.12 109.078 270.31 111.869 269.56V269.56L111.833 269.697C110.864 273.409 111.615 277.36 113.88 280.457L113.964 280.571V280.571C111.093 280.899 108.786 283.088 108.308 285.938L108.064 287.399L107.3 286.13C105.81 283.655 102.86 282.465 100.069 283.215V283.215L100.105 283.078C101.074 279.366 100.322 275.415 98.0573 272.318L97.9738 272.204V272.204C100.845 271.876 103.152 269.687 103.629 266.837L103.874 265.377Z",
    stroke: "white",
    strokeWidth: 0.671701
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7074 238.22L105.014 248.817C107.941 253.734 113.782 256.102 119.306 254.611L126.042 252.794L122.223 267.792C121.289 271.457 122.029 275.347 124.243 278.413L133.304 290.961L126.371 291.744C120.686 292.387 116.122 296.734 115.206 302.382L113.231 314.555L106.924 303.958C103.998 299.041 98.1569 296.673 92.6327 298.164L85.8963 299.981L89.7161 284.983C90.6495 281.318 89.9094 277.428 87.6953 274.361L78.6344 261.814L85.5676 261.031C91.2532 260.388 95.8164 256.04 96.7327 250.393L98.7074 238.22Z",
    stroke: "white",
    strokeWidth: 0.671701
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5517 301.748L126.533 252.378",
    stroke: "white",
    strokeWidth: 0.671701,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.106 319.212L98.321 235.922",
    stroke: "white",
    strokeWidth: 0.671701,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.921 291.337L77.4985 261.446",
    stroke: "white",
    strokeWidth: 0.671701,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotificationsInsideDropdown);
export default __webpack_public_path__ + "static/media/no-notifications-inside-dropdown.dff78545d3cc09b82b327122e476213d.svg";
export { ForwardRef as ReactComponent };